/**
 * Normalizes unknown thrown values (Supabase, fetch, etc.) into a user-visible string.
 */
export function pickErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return 'Something went wrong';
}
